<template>
  <app-panel nested icon="calClock" title="Tarifversionen" flush>
    <template #actions>
      <app-icon-button icon="refresh" label="Aktualisieren" @click="refreshDataGrid" />
      <app-icon-button
        v-if="permission == 'WRITE'"
        icon="plus"
        label="Tarifversion anlegen"
        @click="addRow"
      />
    </template>
    <dx-data-grid
      :id="gridRefName"
      :ref="gridRefName"
      :columns="columns"
      :data-source="dataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      :hover-state-enabled="!gridTouch"
      :allow-column-resizing="!gridTouch"
      :allow-column-reordering="!gridTouch"
      :scrolling="scrolling"
      :element-attr="gridAttr"
      :column-auto-width="true"
      :focused-row-enabled="true"
      @focused-row-changed="onFocusedRowChanged"
      :focused-row-index="0"
      @toolbar-preparing="onToolbarPreparing"
      @editing-start="onEditingStart"
      @row-inserting="onDataChanged"
      @row-updating="onDataChanged"
      @row-removing="onDataChanged"
    >
      <dx-paging :page-size="5" />
      <dx-editing refresh-mode="full" :allow-adding="false" mode="batch" />
    </dx-data-grid>
    <app-save-bar
      v-if="hasChanges"
      class="panel-savebar"
      @save="saveChanges"
      @discard="revertChanges"
    />
  </app-panel>
</template>

<script>
import { DxDataGrid, DxPaging, DxEditing } from "devextreme-vue/data-grid";
import DataGridMixin from "@/mixins/DataGridMixin";
import CustomStore from "devextreme/data/custom_store";
import axios from "axios";
import moment from "moment";

export default {
  components: {
    DxDataGrid,
    DxPaging,
    DxEditing,
  },
  props: ["tariffZoneId", "permission"],
  mixins: [DataGridMixin],
  watch: {
    tariffZoneId() {
      this.refreshDataGrid();
    },
  },
  data() {
    return {
      gridRefName: "tariffVersionDataGrid",
      hasChanges: false,
      // Zeiger auf den Zeilen (Maus): die gewählte Tarifversion steuert die Preise
      gridAttr: { class: "app-grid--detail" },
      columns: [
        {
          dataField: "tariff_version_id",
          caption: "Tarifversion",
          alignment: "left",
          allowEditing: false,
        },
        // {
        //   dataField: "tariff_zone_id",
        //   caption: "Tarifzonen ID",
        // },
        {
          dataField: "valid_from",
          caption: "gültig ab",
          dataType: "date",
          format: "dd.MM.yyyy",
          sortOrder: "desc",
        },
      ],
      dataSource: new CustomStore({
        key: ["tariff_version_id"],
        load: () =>
          axios.get(
            `${this.$store.state.baseUrl}tariffversion?tariff_zone_id=${this.tariffZoneId}`
          ),
        insert: (newTariffVersion) =>
          axios.post(`${this.$store.state.baseUrl}tariffversion`, {
            valid_from: moment(newTariffVersion.valid_from).format("YYYY-MM-DD"),
            tariff_zone_id: this.tariffZoneId,
          }),
        onLoaded: (data) => {
          this.$emit(
            "onTariffversionSelected",
            data.data.length == 0 ? { tariff_version_id: null } : data.data[0]
          );
        },
      }),
    };
  },
  methods: {
    onToolbarPreparing(e) {
      // Remove all default toolbar items
      e.toolbarOptions.items = [];
    },
    onEditingStart(e) {
      if (e && e.data) {
        this.hasChanges = true;
      }
    },
    onDataChanged(e) {
      if (e && e.data) {
        this.hasChanges = true;
      }
    },
    addRow() {
      this.$refs[this.gridRefName].instance.addRow();
    },
    async saveChanges() {
      await this.$refs[this.gridRefName].instance.saveEditData();
      this.hasChanges = false;
    },
    revertChanges() {
      this.$refs[this.gridRefName].instance.cancelEditData();
      this.hasChanges = false;
    },
    refreshDataGrid() {
      this.$refs[this.gridRefName].instance.refresh();
    },
    onFocusedRowChanged(e) {
      this.$emit("onTariffversionSelected", e.row.data);
    },
  },
};
</script>

<style scoped>
/* Speichern-Leiste als Fuß der Karte: .app-panel schneidet (overflow: hidden) und wird damit zum Bezugsrahmen von
   position: sticky; bottom: var(--sticky-unten) würde sie dort auf dem Handy um die untere Navigation anheben. */
.panel-savebar {
  position: static;
}
</style>
